"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    title: {
        id: 'registration.activationCode.title',
        defaultMessage: 'Enter activation code',
        description: 'Registration activation code step title',
    },
    description: {
        id: 'registration.activationCode.description',
        defaultMessage: 'To create your AGCO account, enter the activation code below.',
        description: 'Registration activation code step description',
    },
    label: {
        id: 'registration.activationCode.label',
        defaultMessage: 'Activation code',
        description: 'Registration activation code step label',
    },
    invalidCode: {
        id: 'registration.activationCode.invalidCode',
        defaultMessage: 'The activation code is not valid',
        description: 'Registration activation code step invalid code',
    },
    pasteButton: {
        id: 'registration.activationCode.pasteButton',
        defaultMessage: 'Paste from clipboard',
        description: 'Registration activation code step paste button',
    },
});
exports.default = messages;
